<script lang="ts">
  export let taggedText: string;

  const colorTagRegexp = /<color=(.*?)>(.*?)<\/color>/g;

  let matches: RegExpMatchArray[];
  $: matches = [...taggedText.matchAll(colorTagRegexp)];
  $: firstMatchText = taggedText.slice(0, matches[0]?.index);
  $: lastMatch = matches[matches.length - 1];
  $: lastMatchText = taggedText.slice((lastMatch?.index ?? 0) + (lastMatch?.[0]?.length ?? 0));
</script>

{#if matches.length > 0}
  {firstMatchText}
  {#each matches as match, i}
    {@const color = match[1].toLowerCase()}
    <span data-color={color}>{match[2]}</span>
    {#if matches[i + 1] != undefined}
      {@const matchIndex = match.index ?? 0}
      {@const matchedText = match[0]}
      {taggedText.slice(matchIndex + matchedText.length, matches[i + 1].index)}
    {/if}
  {/each}
  {lastMatchText}
{:else}
  {taggedText}
{/if}

<style lang="postcss">
  span {
    &[data-color='yellow'] {
      color: var(--yellow-11);
    }
    &[data-color='#ffff00'] {
      color: var(--yellow-11);
    }
    &[data-color='green'] {
      color: var(--green-11);
    }
    &[data-color='red'] {
      color: var(--yellow-11);
    }
    &[data-color='#35ff94'] {
      color: var(--text-item-uncommon);
    }
    &[data-color='#2ac0ff'] {
      color: var(--text-item-rare);
    }
    &[data-color='#d05eff'] {
      color: var(--text-item-epic);
    }
    &[data-color='#01ac01'] {
      color: var(--plus);
    }
    &[data-color='#008000'] {
      color: var(--green-10);
    }
    &[data-color='#688a08'] {
      color: var(--grass-10);
    }
    &[data-color='#dda0dd'] {
      color: var(--pink-10);
    }
  }
</style>
